
import _ from "lodash";

export const capitalizeFirstLetter = (string: string) => {
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return "";
    }
};
 
export const currencyFormat=(price: any)=> {
  price=String(price);
  if(price == null)
  {
    price = '00';
  }
  if (price) {
    return '$ ' + price.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  } else {
    return "";
  }
}

export const calculateGroupedTotals = (data: any[]) => {
  if (!Array.isArray(data)) return data;

  const leafCodes = ["VP", "VP/IP", "IP"];
  const groupCodes = ["SST", "ST", "GT"];

  // 1. Separate leaves (VP, VP/IP, IP)
  const leaves = data.filter(item =>
    leafCodes.includes(item.account_chart?.report_code)
  );

  // 2. Prepare a grouped index for fast lookup
  const leafIndex = _.groupBy(leaves, (leaf: any) => leaf.account_chart.account);

  // 3. Map over full input array and only update SST/ST/GT nodes
  const updatedData = data.map(item => {
    const code = item.account_chart?.report_code;

    // Only update SST, ST, GT
    if (!groupCodes.includes(code)) {
      return item; // return unchanged
    }

    const start_range = item.account_chart.parent?.start_range || 0;
    const end_range = item.account_chart.account || 0;

    if (start_range > end_range) {
      return { ...item, total_amount: 0, prev_year_total_amount: 0 }; // invalid range
    }

    // 4. Collect all leaf nodes in the given range
    const matchedLeaves = _.flatten(
      _.range(start_range, end_range + 1).map((acc: any) => leafIndex[acc] || [])
    );

    // 5. Sum all totals within the range
    const total = _.sumBy(matchedLeaves, "total_amount");
    const prevYearTotal = _.sumBy(matchedLeaves, "prev_year_total_amount");

    // 6. Return updated object with new total_amount
    return {
      ...item,
      total_amount: total,
      prev_year_total_amount: prevYearTotal
    };
  });

  return updatedData;
};

/**
 * A transaction breakdown whose master_chart_of_account_id does not resolve to a
 * chart row still carries real money. Two ways that happens:
 *
 *   - master_chart_of_account_id = 0, the *designed* "not yet classified" marker
 *     for Adjusted_Bank_Deposit legs on is_pos=3 branches (gl-api
 *     transaction_account/controller.py writes the balancing debit leg with 0 and
 *     the Sales GL Classification screen is where the user assigns it).
 *   - a stale id left behind by a COA re-import, which resolves to null the same way.
 *
 * Every rendering branch in ViewRegister is gated on `if (breakdown.account_chart)`
 * and falls through to `return null`, so such a line was dropped from the display
 * AND from the debit/credit totals. Its Gross_Sale / State_Tax credit siblings were
 * still counted, so the register reported "debits and credits differ by X" where X
 * is exactly the hidden amount, with no visible row to attribute it to.
 *
 * Mutates in place and returns the same array, so callers can use it inline.
 * Zero-value legs are left alone: State_Tax is written as 0.00 with account 0 on
 * every sales activity, and surfacing those would add a $0.00 row to each one.
 */
export const fillUnresolvedAccountCharts = (breakdowns: any[], unclassifiedLabel: string) => {
    (breakdowns || []).forEach((breakdown: any) => {
        if (!breakdown.account_chart && Number(breakdown.account_value) !== 0) {
            breakdown.account_chart = {
                id: 0,
                name: unclassifiedLabel,
                account: '—',
                revrex_account_id: null
            };
        }
    });
    return breakdowns;
};
